<template>
  <div class="bottom">
    <div style="flex: 1; width: 1px;" />
    <div class="linksBox">
      <div class="linksItemHeader linksLogoHeader">
        <img class="logoImage" src="@/assets/logo.png" />
      </div>
      <div class="linksItemHeader">关注我们</div>
      <div class="linksItemHeader">产品下载</div>

      <div class="linksItemText">
        <img class="textIcon" src="@/assets/bottom0.png" />
        <div class="textText">
          上海市徐汇区绿地中心- A座1502C
        </div>
      </div>

      <div class="linksItemText">
        <span>微信公众号：</span>

        <span
          class="linksClickable qrTrigger ml-1"
          @mousemove="showQR(1)"
          @mouseout="hideQR"
        >
          Pulse治愈
          <transition name="qr_show">
            <div class="linksQR" v-if="isShowQR && qrIndex === 1">
              <img class="linksQRBox" src="../assets/icon_qr_holder.png" />
              <img class="linksQRImage" src="../assets/qr_01.jpg" />
            </div>
          </transition>
        </span>

        <span
          class="linksClickable qrTrigger ml-2"
          @mousemove="showQR(2)"
          @mouseout="hideQR"
        >
          Pulse健康
          <transition name="qr_show">
            <div class="linksQR" v-if="isShowQR && qrIndex === 2">
              <img class="linksQRBox" src="../assets/icon_qr_holder.png" />
              <img class="linksQRImage" src="../assets/qr_02.jpg" />
            </div>
          </transition>
        </span>
      </div>

      <div class="linksItemText">
        <span class="linksClickable">Pulse治愈</span>
        <span class="linksClickable ml-2">Pulse健康</span>
      </div>

      <div class="linksItemText">
        <img class="textIcon" src="@/assets/bottom1.png" />
        <div class="textText">
          (021) 63307977
        </div>
      </div>

      <div class="linksItemText"></div>
      <div class="linksItemText"></div>

      <div class="linksItemText">
        <img class="textIcon" src="@/assets/bottom2.png" />
        <div class="textText">
          info@dopulses.com
        </div>
      </div>

      <div class="linksItemText">
        <span class="linksClickable" @click="openUrl(weiboURL)">微博</span>
        <span class="linksClickable ml-3" @click="openUrl(tiktokURL)">抖音</span>
        <span class="linksClickable ml-4" @click="openUrl(xiaohongshuURL)">小红书</span>
        <span class="linksClickable ml-5" @click="openUrl(bilibiliURL)">B站</span>
      </div>

      <div class="linksItemText">
        <span
          class="linksClickable qrTrigger"
          @mousemove="showQR(3)"
          @mouseout="hideQR"
        >
          健康脑小程序
          <transition name="qr_show">
            <div class="linksQR" v-if="isShowQR && qrIndex === 3">
              <img class="linksQRBox" src="../assets/icon_qr_holder.png" />
              <img class="linksQRImage" src="../assets/qr_03.jpg" />
            </div>
          </transition>
        </span>

        <span
          class="linksClickable qrTrigger ml-2"
          @mousemove="showQR(4)"
          @mouseout="hideQR"
        >
          Pulse治愈小程序
          <transition name="qr_show">
            <div class="linksQR" v-if="isShowQR && qrIndex === 4">
              <img class="linksQRBox" src="../assets/icon_qr_holder.png" />
              <img class="linksQRImage" src="../assets/qr_04.jpg" />
            </div>
          </transition>
        </span>
      </div>
    </div>

    <div class="splitLine"></div>

    <div class="copyrightText">
      © 2020 all rights reserved - MutationMedia.A product of mutationthemes.
      <br />
      <span class="recordLink" @click="toURL('https://beian.miit.gov.cn')">
        沪ICP备2022002355号
      </span>
      <span class="recordLink" @click="toURL('https://beian.miit.gov.cn')">
        <img class="beianIcon" src="../assets/beian.png" />
        沪公网安备31010402334709号
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowQR: false,
      qrIndex: 0,
      weiboURL: "https://weibo.com/u/7749191157",
      tiktokURL:
        "https://www.douyin.com/user/MS4wLjABAAAApK_Sycnh1Lx7_WSgPzFZx73176iQ1ceQxZheGV2fF1Qm7HJAhAdRvRjKBb0Fac_1",
      xiaohongshuURL:
        "https://www.xiaohongshu.com/user/profile/61a5a181000000001000eb11",
      bilibiliURL: "https://space.bilibili.com/2004340746?"
    };
  },
  methods: {
    toURL(url) {
      window.open(url, "_blank");
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    showQR(index) {
      this.isShowQR = true;
      this.qrIndex = index;
    },
    hideQR() {
      this.isShowQR = false;
    }
  }
};
</script>

<style scoped>
.bottom {
  position: relative;
  width: 100%;
  height: 39.4rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #666666;
  background-color: #ffffff;
}

.linksBox {
  width: 100rem;
  display: grid;
  grid-template-columns: 40rem 1fr max-content;
  grid-template-rows: 5.1667rem 3.37rem 3.37rem 3.37rem;
  justify-content: start;
  align-items: center;
}

.linksItemHeader {
  color: #666666;
  font-size: 1.33rem;
  text-align: left;
}

.linksLogoHeader {
  display: flex;
  align-items: center;
}

.logoImage {
  width: 7.2rem;
  height: 3rem;
  object-fit: contain;
  display: block;
}

.linksItemText {
  color: rgba(102, 102, 102, 0.7);
  font-size: 1.33rem;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .textIcon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.8rem;
    display: inline-block;
  }
  .textText {
    color: rgba(102, 102, 102, 0.7);
    font-size: 1.33rem;
    user-select:text;
  }
}

.linksClickable {
  cursor: pointer;
}
.linksClickable:hover {
  color: #78DFA2;
}

.qrTrigger {
  position: relative;
  display: inline-block;
}

.linksQR {
  position: absolute;
  top: 1.44rem;
  left: 0;
  z-index: 10;
}

.linksQRBox {
  position: absolute;
  width: 4.38rem;
  height: 4.81rem;
}

.linksQRImage {
  position: absolute;
  top: 0.68rem;
  left: 0.31rem;
  width: 3.84rem;
  height: 3.84rem;
}

.qr_show-enter,
.qr_show-enter-from,
.qr_show-leave-to {
  opacity: 0;
}

.qr_show-enter-to,
.qr_show-leave,
.qr_show-leave-from {
  opacity: 1;
}

.qr_show-enter-active,
.qr_show-leave-active {
  transition: opacity 200ms linear;
}

.splitLine {
  width: 1200px;
  height: 0.06rem;
  margin-top: 5.75rem;
  margin-bottom: 1.44rem;
  background-color: #333333;
  opacity: 0.2;
}

.copyrightText {
  margin-bottom: 1.87rem;
  color: #666666;
  opacity: 0.7;
  font-size: 1.1rem;
  line-height: 1.85;
  text-align: center;
}

.recordLink {
  cursor: pointer;
}

.beianIcon {
  width: 0.88rem;
  height: 0.88rem;
  margin-right: 0.3rem;
  vertical-align: -0.1rem;
  display: inline-block;
}

/* margin 工具类 */
.ml-1 {
  margin-left: 1.07rem;
}

.ml-2 {
  margin-left: 1.62rem;
}

.ml-3 {
  margin-left: 3.88rem;
}

.ml-4 {
  margin-left: 3.43rem;
}

.ml-5 {
  margin-left: 3.56rem;
}
</style>